import { createReducer } from 'redux-act';
import actions from '../actions/reportAction';

const initialState = {
  salaryReportPending: false,
  salaryReportRes: null,
  salaryReportError: null,

}

/* Salary Report Reducers */
const handleSalaryReportRequest = state => {
  return {
    ...state,
    ...{
      salaryReportPending: true,
      salaryReportRes: null,
      salaryReportError: null,
    },
  };
};
const handleSalaryReportSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      salaryReportPending: false,
      salaryReportRes: payload,
      salaryReportError: null,
    },
  };
};
const handleSalaryReportError = (state, payload) => ({
  ...state,
  ...{
    salaryReportPending: false,
    salaryReportRes: null,
    salaryReportError: payload,
  },
});




/* Clear Report Store */
const clearReportStore = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_SALARY_REPORT_STORE':
      return {
        ...state,
        ...{
          salaryReportPending: false,
          salaryReportRes: null,
          salaryReportError: null,
        },
      };
   
    default:
      return state;
  }
};



export default createReducer(
  {
    [actions.salaryReportRequest]: handleSalaryReportRequest,
    [actions.salaryReportSuccess]: handleSalaryReportSuccess,
    [actions.salaryReportError]: handleSalaryReportError,

    [actions.handleClearReportStore]: clearReportStore,
  },
  initialState,
);